<template>
    <form @submit.prevent="onSubmit" class="form-horizontal form-material">
        <div class="card text-white bg-danger" v-if="errors">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Validation Errors</h4>
            </div>
            <div class="card-body">
                <p v-if="typeof errors === 'string'" class="card-text">{{errors}}</p>
                <p v-else class="card-text" v-for="(error, key) in errors" :key="key">
                    {{key}}: {{error}}
                </p>
            </div>
        </div>
        <br/>

        <treeselect v-model.trim="category" placeholder="Select Category" :multiple="false" :options="categories"
                    search-nested :normalizer="normalizer"/>
        <div class="text-danger" v-if="$v.category.$error">Category is required.</div>
        <br>

        <div class="row">
            <div class="col-md-6">
                <div class="form-group" :class="{ 'form-group--error': $v.subscriberEmail.$error }">
                    <label for="unsubscribe_email" class="mb-1">Enter Email</label>
                    <input v-model.trim="$v.subscriberEmail.$model" type="text" class="form-control" name="unsubscribe_email" 
                           id="unsubscribe_email">
                    <div v-if="$v.subscriberEmail.$error">
                        <div class="text-danger" v-if="!$v.subscriberEmail.email">Invalid email.</div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm">
                <label class="mb-1">Choose file</label>
                <div class="form-group row">
                    <div class="col-auto">
                        <button class="btn btn-info" @click.prevent="uploadFile">Browse&hellip;</button>
                        <input @change="handleFileUpload($event)" id="file" ref="file" type="file" style="display: none;">
                    </div>
                    <div class="col-12 col-sm col-xl">
                        <input class="form-control" :value="file.name" readonly>
                    </div> 
                </div>
            </div>
        </div>

        <div class="alert alert-info">
            <i class="fas fa-info"></i> Enter an <b>email</b> OR Select a <b>txt/csv</b> file with emails
            <button type="button" class="close" data-dismiss="alert" aria-label="Close"></button>
        </div>

        <div class="form-group text-center p-b-20 p-t-20">
            <div class="col-xs-12">
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light">
                    Create Unsubscriber
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import Breadcrumb from '../../components/Breadcrumb';
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import CategoryService from '../../services/CategoryService'
    import UnsubscriberService from '../../services/UnsubscriberService';
    import {required, email} from 'vuelidate/lib/validators';
    import Preloader from '../../components/Preloader';

    export default {
        name: 'Unsubscriber',
        components: {Breadcrumb, Treeselect, Preloader},
        data() {
            return {
                category: null,
                categories: [],
                errors: '',
                subscriberEmail: '',
                file: '',
                showPreloader: false,
                normalizer(node) {
                    return {
                        id: node.id,
                        label: node.text,
                        children: node.children
                    }
                }
            }
        },
        mounted() {
            CategoryService.getCategories().then(response => (this.categories = response.data));
        },
        validations: {
            category: {required},
            subscriberEmail: {email}
        },
        methods: {
            onSubmit() {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    this.showPreloader = true;
                    let self = this;
                    let postData = {
                        category: this.category,
                        email: this.subscriberEmail,
                        file: this.file
                    };
                    let formData = new FormData();
                    formData.append('data', JSON.stringify(postData));
                    formData.append('file', this.file);

                    UnsubscriberService.createUnsubscriber(formData)
                        .then(response => {
                            if(response.status >= 400) {
                                this.errors = response.data.error;
                            } else {
                                self.$router.push({name: 'unsubscribers'});
                            }
                            this.showPreloader = false;
                        });
                }
            },
            handleFileUpload(event) {
                let docum = event.target.files[0];
                this.file = docum;
            },
            uploadFile() {
                this.$refs.file.click();
            }
        }
    }
</script>